import React, { Component } from 'react';


class InputText extends Component {
    constructor(props) {
        super(props);

        this.onInputChange = this.onInputChange.bind(this);
    }

    onInputChange(event) {
        this.props.onChange(event);
    }

    render() {
        const {
 width, className, value, title, disabled, pattern, onkeypress, onkeydown, onkeyup, maxLength,
} = this.props;

        return (
        <div>
            <input
                style={{ width: width && width }}
                className={className && className}
                type="text"
                title={title && title}
                pattern={pattern && pattern}
                onKeyPress={onkeypress && onkeypress}
                onKeyDown={onkeydown && onkeydown}
                onKeyup={onkeyup && onkeyup}
                // allowEdit={false}
                // placeholder="00"
                onChange={this.onInputChange}
                maxLength={maxLength && maxLength}
                // onBlur={this.UpdateDays.bind(this)}
                disabled={disabled && disabled}
                value={value}
                size={maxLength}
            />
        </div>);
    }
}

export default InputText;
